import Reveal from './Reveal';
import { profileTable } from '@/mocks/home';

export default function ProfileTable() {
  return (
    <section id="profile-table" className="py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <span className="text-xs tracking-[0.3em] text-accent-700 uppercase">Fact Sheet</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">基本资料一览</h2>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                下表为可公开检索到的信息条目。由于当事人长期匿名，部分条目只能给出大致范围。
              </p>
              <div className="mt-6 flex items-center gap-3 text-xs text-secondary-800">
                <i className="ri-information-line text-base"></i>
                <span>信息持续更新，以公开资料为准</span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={100} className="lg:col-span-8">
            <dl className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {profileTable.map((row, idx) => (
                <div
                  key={row.label}
                  className={`grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-4 px-5 py-4 ${
                    idx !== profileTable.length - 1 ? 'border-b border-background-100' : ''
                  }`}
                >
                  <dt className="text-sm text-secondary-700 sm:pt-0.5">{row.label}</dt>
                  <dd className="sm:col-span-2 text-sm font-medium text-foreground-900">{row.value}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>
  );
}